import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder, createFakeDeleteResponder, createFakePutResponder } from '../test-utils';
import { createUsersApi } from './';
import { createSimpleCustomFieldsApiTestKitHandler } from '../custom-fields/testkit';
export var createUsersApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createUsersApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenAdminSearch: function (dto) {
            return createFakePostResponder(fakeHttp, '/users/search/admin')(dto);
        },
        whenDashboardSearch: function (dto) {
            return createFakePostResponder(fakeHttp, '/users/dashboard/search')(dto);
        },
        whenAgentSearch: function (dto) {
            return createFakePostResponder(fakeHttp, '/agents/search')(dto);
        },
        whenGetUser: function (dto) {
            return createFakeGetResponder(fakeHttp, "/users/".concat(dto.id));
        },
        whenGetMe: function () {
            return createFakeGetResponder(fakeHttp, '/users/me');
        },
        whenAddUser: createFakePostResponder(fakeHttp, "/users"),
        whenBulkAddUsers: createFakePostResponder(fakeHttp, "/users/bulk"),
        whenGetAgents: function (dto) {
            return createFakeGetResponder(fakeHttp, "/agents?userType=".concat(dto.userType));
        },
        whenUnbanUser: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/users/".concat(dto.id, "/ban"));
        },
        whenBanUser: function (dto) {
            return createFakePostResponder(fakeHttp, "/users/".concat(dto.id, "/ban"))(dto);
        },
        whenUpdateUsersCompany: createFakePutResponder(fakeHttp, "/users/company"),
        whenSetUserCompanies: function (dto) { return createFakePutResponder(fakeHttp, "/users/".concat(dto.userId, "/companies"))(dto.data); },
        whenAddUserNote: function (dto) {
            return createFakePostResponder(fakeHttp, "/users/".concat(dto.id, "/notes"))(dto);
        },
        whenGetUserNotes: function (dto) { return createFakeGetResponder(fakeHttp, "/users/".concat(dto.id, "/notes")); },
        whenGetBanState: function (dto) { return createFakeGetResponder(fakeHttp, "/users/".concat(dto.id, "/ban")); },
        whenCustomFields: createSimpleCustomFieldsApiTestKitHandler('/users', fakeHttp),
        whenUpdateUserCustomFields: function (dto) {
            return createFakePutResponder(fakeHttp, "/users/".concat(dto.id, "/fields"))(dto);
        },
        whenUpdateUser: function (dto) {
            return createFakePutResponder(fakeHttp, "/users/".concat(dto.userId))(dto.data);
        },
        whenSetUsersCompanies: function (dto) { return createFakePutResponder(fakeHttp, "users/companies")(dto); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map